export default {
  banner: {
    title: "Authing 让身份管理变得简单",
    subtitle:
      "Authing 作为优秀的身份管理解决方案提供商，无论在 B2B，B2C，B2E 或 IoT 场景，都会为企业带来显著的竞争优势：降低开发成本、提高安全性、助力生产效率。",
  },
  security: {
    title: "高安全",
    subtitle:
      "Authing 上线之初，就被中国信息通讯研究院评选为“国内身份管理与访问控制领域创新企业”，并被录入《2019 年网络安全产业白皮书》",
    item0: "现有功能零 BUG，零漏洞",
    item1: "密钥管理基础设施（KMS）",
    item2: "标准 JWT Token 支持非对称加密",
    item3: "支持 RBAC/ABAC",
    item4: "通过 ISO 质量体系认证",
    item5: "安全合作伙伴",
  },
  performance: {
    title: "高性能",
    "item-one": {
      title: "业务系统能弹性扩容支撑十亿用户",
      "list-one": "毫秒级查询记录",
      "list-two": "毫秒级写入速度",
    },
    "item-two": {
      title: "跨云基础设施，弹性伸缩",
      "list-one": "冗余架构，冗余存储",
      "list-two": "无单点故障，高可靠",
      "list-three": "架构一键复制到公有云/专有云/私有云",
      "list-four": "鼠标一键扩容",
      "list-five": "可视化管理工具",
    },
  },
  productive: {
    title: "高生产力",
    "item-one": {
      title: "跨平台",
      subtitle: "毫秒级查询记录",
    },
    "item-two": {
      title: "海量接口",
      subtitle: "RESTful,GraphQL,SDK",
    },
    "item-three": {
      title: "文档",
      subtitle: "可交互，User-Centered，全面的文档",
    },
    "item-four": {
      title: "Serverless",
      subtitle: "腾讯云，阿里云，AWS",
    },
    "item-five": {
      title: "多协议",
      subtitle: "OAuth 2.0,OIDC,SAML,AD/LDAP, WS-Fed",
    },
    "item-six": {
      title: "优雅的身份中台",
      subtitle: "用户增长，权限控制，SQL 或代码级数据查询，日志，审计",
    },
    "item-seven": {
      title: "高扩展性",
      subtitle:
        "插件，pipeline 流水线，域名，无限定自定义登录框（样式/布局），多数据库兼容",
    },
    "item-eight": {
      title: "零人工部署",
      subtitle: "按量部署，自动更新",
    },
  },
  extend: {
    title: "无供应商锁定",
    "item-one": {
      title: "导出数据",
      content:
        "Authing 提供完整便捷的数据导出功能，用户可以随时从平台将自己的数据完全迁移出去，Authing 不会保留任何用户的数据。",
    },
    "item-two": {
      title: "标准协议",
      content:
        "Authing 支持使用 OIDC、SAML、OAuth 等市场所有主流协议，客户可自由选择。",
    },
    "item-three": {
      title: "自定义流程",
      content:
        "Authing 支持自定义认证流程（Pipeline），客户可以更改认证流程，插拔需要的功能，例如邀请码注册逻辑、删除需要动态验证登录的模块等场景。",
    },
  },
  developer: {
    title: "开发者友好",
    "descript-one": {
      content:
        "Authing 拥有 700+ 开放接口，支持 RESTful 和 GraphQL，以及 Python、JavaScript、Node、PHP、Java、Swift、Rust 等编程语言和框架，满足 Web、iOS、Android 或其他后端各平台的使用需求。Authing 全面支持 Serverless 架构，有和 Serverless 安全兼容的 OIDC 框架，可以实现安全的单点登录和身份认证。多语言、跨平台、直观、友好、丰富的 SDK 支持。",
      link: "了解更多",
    },
    "descript-two": {
      content:
        "Authing 兼容 Oddo Wordpress c9.io Strapi 等主流业务的头部开源软件，极大程度地为企业和个人开发者降低了接入使用的工作量，Authing 支持 OAuth2.0 OIDC SAML AD/LDAP JWT CAS SWA 等所有主流认证协议，同时是 SoLiD 项目亚洲节点运营方。",
      link: "了解更多",
    },
  },
  deployment: {
    title: "支持私有部署",
    content:
      "Authing 可根据企业需求提供定制化私有部署解决方案，让企业的身份管理更简单。整个过程中专业的技术人员会全程参与整个解决方案的部署和售后，提供全方位的客户服务。",
  },
  success: {
    title: "确保你的成功是我们的工作",
    "content-one":
      "Authing 支持个性化定制和私有化部署。方案组全程跟进定制化业务需求，可部署企业本地服务器，数据安全可控。 ",
    "content-two":
      "客户成功团队从接口联调、测试上线到后期系统运维、管理平台使用等各方向全面提供 7*24 小时不间断服务。",
  },
};
